<template>
  <main class="thanks grid" style="opacity: 0; visibility: hidden;">
    <div class="thanks__inner container">
      <section class="info">
        <div>
          <FormThanks
            :name="this.$route.params.name"
          />
        </div>
      </section>
    </div>
    <div class="thanks__footer container">
      <div class="info__footer">
        <ul data-anim="list">
          <li>
            <router-link
              to="/"
              class="fx"
            >
              <span><small>Back to home</small></span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </main>
</template>

<script>
import FormThanks from '@/components/Form/FormExtra/FormThanks.vue';

export default {
  name: 'Thanku',

  components: {
    FormThanks,
  },
};
</script>

<style lang="scss" scoped>
.thanks {
  @include mq(ipadP) {
    height: 100vh;
  }

  &__inner {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;

    padding-top: rem(40px);
    padding-bottom: rem(40px);

    @include mq(ipadP) {
      padding-top: 0;
      padding-bottom: 0;
    }

    section {
      flex-basis: 100%;

      @include mq(ipadP) {
        margin-top: rem(160px);

        flex-basis: calc(50% - #{$gutter});
      }
    }
  }

  .form {
    order: 1;
    padding: rem(40px) 0 rem(80px);

    @include mq(ipadP) {
      // order: 0;
      padding: 0;
    }
  }

  .info {
    order: 0;

    padding: 0;

    @include mq(ipadP) {
      padding-top: 28px;
    }

    h6 {
      margin-top: 0;
    }

    /deep/ p {
      color: RGB($color-text);
    }

    & > * {
      flex: 1 0 0;
    }
  }

  .info {
    &__footer {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: rem(80px);

      @include mq(ipadP) {
        margin-bottom: 0;
        align-items: flex-end;
      }
      ul {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        width: 100%;

        li {
          @include mq(ipadP) {
            flex: 0 0 50%;
            flex-basis: calc(50% - #{$gutter});
          }

          &:first-child {
            margin-bottom: rem(40px);

            @include mq(ipadP) {
              margin-top: 0;
              // margin-right: rem(100px);
            }
          }
        }

        h6 {
          margin: 0 0 0.5em 0;
        }
      }
    }
  }
}
</style>
